export default __webpack_public_path__ + "static/media/creatine.ddc2be9a.png";